module.exports = __webpack_public_path__ + "img/services-01-landscape.9e457c07.jpg";